// For calling /init/
export interface SurveyResolverStartPayload {
  sessionId: string;
  invitationId: string;
  surveyId: number;
  loginType: SurveyLoginType;
  [key: string]: string | number | boolean | string[] | undefined; // For spread query params
}

// For calling /start/
export interface SurveyStartSessionPayload {
  token: string;
}

// handshake.types.ts
export enum SurveyAccessType {
  DIRECT = "direct",
  LOGIN = "login",
  SESSION = "session",
}

export enum HandshakeMode {
  AUTHORIZED = "authorized", // Ready to call /start
  RESTART = "restart", // Cookie found, resume session
  NEEDS_LOGIN = "needs_login", // Show StartConsent/Login page
  ERROR = "error",
}

export enum SurveyLoginType {
  SESSION = "session",
  INVITATION = "invitation",
  SELF_SERVE = "self_serve",
}
